import { render } from "./ProductOption.vue?vue&type=template&id=8a72624e"
import script from "./ProductOption.vue?vue&type=script&lang=js"
export * from "./ProductOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__